import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'removeTooltip'
  | 'selectFile'
  | 'dragDropMessage'
  | 'addAnotherFile'
  | 'removeFile';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  removeTooltip: {
    id: 'boxFileRequest.dropZone.removeTooltip',
    description: 'Tooltip message for remove',
    defaultMessage: 'Remove',
  },
  selectFile: {
    id: 'boxFileRequest.dropZone.selectFile',
    description: 'Button text for selecting file',
    defaultMessage: 'Select Files',
  },
  dragDropMessage: {
    id: 'boxFileRequest.dropZone.dragDropMessage',
    description: 'Prompt text for drag drop area',
    defaultMessage: 'Drag and drop files',
  },
  addAnotherFile: {
    id: 'boxFileRequest.dropZone.addAnotherFile',
    description: 'Button text for add another file',
    defaultMessage: 'Add another file',
  },
  removeFile: {
    id: 'boxFileRequest.dropZone.removeFile.label',
    description:
      'Accessible label for an "x" button that removes a file from an upload zone, where fileName is the name of the file',
    defaultMessage: 'Remove file {fileName}',
  },
});

export default messages;
